$(document).ready(function () {
  setTimeout(() => {
    $(".product-raw-dog-food-blt .shopify-product-form .selector-wrapper .single-option-selector[data-option=option1]").change(function () {
      var optionValue = $(this).val();
      let CurrentSibling = $(this).parents(".selector-wrapper").siblings(".selector-wrapper");
      
      if (optionValue === '2 LB') {
        console.log("working");
      
        $(CurrentSibling).find("option").hide();
        $(CurrentSibling).find("option[value='16 LBS - 8 tubes']").show();
        $(CurrentSibling).find("option[value='24 LBS - 12 tubes']").show();

        $(this).parents(".selector-wrapper").siblings(".selector-wrapper").find(".single-option-selector[data-option=option2]").val('16 LBS - 8 tubes');
        console.log($(this).parents(".selector-wrapper").siblings(".selector-wrapper").find(".single-option-selector").val());
        
        // $(CurrentSibling).find(".single-option-selector").val($(CurrentSibling).find("option[value='16 LBS - 8 tubes']").attr('value'));
  
      } else if (optionValue === '5 LB') {
        console.log("working");
  
        $(CurrentSibling).find("option").hide();
        $(CurrentSibling).find("option[value='30 LBS - 6 tubes']").show();

        $(this).parents(".selector-wrapper").siblings(".selector-wrapper").find(".single-option-selector[data-option=option2]").val('30 LBS - 6 tubes');
        console.log($(this).parents(".selector-wrapper").siblings(".selector-wrapper").find(".single-option-selector").val());
        
        // $(CurrentSibling).find(".single-option-selector").val($(CurrentSibling).find("option[value='30 LBS - 6 tubes']").attr('value'));
      }
      $(this).parents(".selector-wrapper").siblings(".selector-wrapper").find(".single-option-selector[data-option=option2]").change();
    });
    $(".product-raw-dog-food-blt .shopify-product-form .selector-wrapper .single-option-selector").change();
  }, 2000);
});